function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.717 18.794a9 9 0 112.121-2.121l4.66 4.66-2.122 2.12-4.66-4.659zm.785-7.336a6 6 0 11-12 0 6 6 0 0112 0z",
  fill: "#81858D"
});

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43MTY4IDE4Ljc5NDRDMTQuMjQ1NSAxOS44NDIxIDEyLjQ0NTcgMjAuNDU4MyAxMC41MDIgMjAuNDU4M0M1LjUzMTM5IDIwLjQ1ODMgMS41MDE5NSAxNi40Mjg4IDEuNTAxOTUgMTEuNDU4M0MxLjUwMTk1IDYuNDg3NjkgNS41MzEzOSAyLjQ1ODI1IDEwLjUwMiAyLjQ1ODI1QzE1LjQ3MjUgMi40NTgyNSAxOS41MDIgNi40ODc2OSAxOS41MDIgMTEuNDU4M0MxOS41MDIgMTMuNDAyIDE4Ljg4NTggMTUuMjAxOCAxNy44MzgxIDE2LjY3MzFMMjIuNDk3NiAyMS4zMzI2TDIwLjM3NjMgMjMuNDUzOUwxNS43MTY4IDE4Ljc5NDRaTTE2LjUwMiAxMS40NTgzQzE2LjUwMiAxNC43NzIgMTMuODE1NyAxNy40NTgzIDEwLjUwMiAxNy40NTgzQzcuMTg4MjQgMTcuNDU4MyA0LjUwMTk1IDE0Ljc3MiA0LjUwMTk1IDExLjQ1ODNDNC41MDE5NSA4LjE0NDU0IDcuMTg4MjQgNS40NTgyNSAxMC41MDIgNS40NTgyNUMxMy44MTU3IDUuNDU4MjUgMTYuNTAyIDguMTQ0NTQgMTYuNTAyIDExLjQ1ODNaIiBmaWxsPSIjODE4NThEIi8+Cjwvc3ZnPg==";
export { SvgSearch as ReactComponent };